module.exports = __webpack_public_path__ + "static/img/1000000439_green.613081dd.jpg";